import React from 'react';
import '../../styles/aboutStyles.css';
import { FaTwitter, FaFacebook, FaLinkedin, FaYoutube } from 'react-icons/fa';
import ReactReadMoreReadLess from 'react-read-more-read-less';

export default function AboutUs() {
    const { clientWidth } = document.body;

    return (
        <div className='about'>
            <div className='about-header'>
                <div className='about-header-inner'>
                    <h1>Our Journey</h1>
                    <hr />
                    <i>Success Through Innovation.</i>
                </div>
            </div>

            <div className='history'>
                <div className='history-text-container'>
                    <h1>HIT Background History</h1>
                    {clientWidth < 768 ? (
                        <ReactReadMoreReadLess
                            charLimit={400}
                            readMoreText={'Read More'}
                            readLessText={'Read Less'}
                            readMoreStyle={{
                                color: 'dodgerblue',
                            }}
                            readLessStyle={{
                                color: 'dodgerblue',
                            }}
                        >
                            Harare Institute of Technology (HIT) was established in 1988 as a
                            National Vocational Training Centre (NVTC). Overtime, it evolved into a
                            Technical College offering courses in automotive, electrical, and
                            mechanical engineering, producing artisans capable of operating and
                            maintaining machinery in industry with little or no research or
                            generation of new technology related knowledge. The University conducts
                            research, design, manufacture, develop, incubate, transfer, and
                            commercialise technology for all sectors of the economy. Harare
                            Institute of Technology produces highly qualified technical human
                            capital that is creativity driven, project oriented, understand all
                            stages of invention including idea generation and development and have
                            the ability, stamina and courage to set up high-tech enterprises. HIT
                            was granted degree awarding status in 2005 with the promulgation of the
                            Harare Institute of Technology Act (Chapter 25:26). Harare Institute of
                            Technology is the hub of technology development and delivery of quality
                            technology programmes at undergraduate and postgraduate level. HIT is
                            Zimbabwe’s most energetic and responsive institute offering unparalleled
                            educational opportunities for those seeking highest quality
                            undergraduate, postgraduate and continuous professional development. It
                            is at the forefront of growing Zimbabwe’s industrial base and natural
                            resources beneficiation.
                        </ReactReadMoreReadLess>
                    ) : (
                        <p>
                            Harare Institute of Technology (HIT) was established in 1988 as a
                            National Vocational Training Centre (NVTC). Overtime, it evolved into a
                            Technical College offering courses in automotive, electrical, and
                            mechanical engineering, producing artisans capable of operating and
                            maintaining machinery in industry with little or no research or
                            generation of new technology related knowledge. The University conducts
                            research, design, manufacture, develop, incubate, transfer, and
                            commercialise technology for all sectors of the economy. Harare
                            Institute of Technology produces highly qualified technical human
                            capital that is creativity driven, project oriented, understand all
                            stages of invention including idea generation and development and have
                            the ability, stamina and courage to set up high-tech enterprises. HIT
                            was granted degree awarding status in 2005 with the promulgation of the
                            Harare Institute of Technology Act (Chapter 25:26). Harare Institute of
                            Technology is the hub of technology development and delivery of quality
                            technology programmes at undergraduate and postgraduate level. HIT is
                            Zimbabwe’s most energetic and responsive institute offering unparalleled
                            educational opportunities for those seeking highest quality
                            undergraduate, postgraduate and continuous professional development. It
                            is at the forefront of growing Zimbabwe’s industrial base and natural
                            resources beneficiation.
                        </p>
                    )}
                </div>

                <div className='history-image-container'>
                    <img
                        src={require('../../images/about/journey2.jpg')}
                        alt=''
                        className='history-image'
                    />
                </div>
            </div>

            <div className='values'>
                <div className='values-text-container'>
                    <h1>Vision & Values</h1>

                    <div className='values-text-item'>
                        <h4>Our Destiny</h4>
                        <span>To be the stimulant of scholarship in innovation.</span>
                    </div>

                    <div className='values-text-item'>
                        <h4>Our Cause</h4>
                        <span>To cultivate commitment towards technopreneurial leadership.</span>
                    </div>

                    <div className='values-text-item'>
                        <h4>Our Calling</h4>
                        <span>
                            To commercialise technology through professionalism rooted in integrity.
                        </span>
                    </div>

                    <div className='values-text-item'>
                        <h4>Our Core Values</h4>
                        <ul>
                            <li>Innovation</li>
                            <li>Leadership</li>
                            <li>Integrity</li>
                            <li>Commitment</li>
                            <li>Professionalism</li>
                        </ul>
                    </div>
                </div>

                <div className='values-image-container'>
                    <img
                        src={require('../../images/about/journey4.jpg')}
                        alt=''
                        className='values-image'
                    />
                </div>
            </div>

            <div className='contact-us'>
                <h1>Contact Us</h1>

                <div className='contact-us-items'>
                    <div className='contact-us-item'>
                        <h1>Postal Address</h1>
                        <span>Harare Institute of Technology</span>
                        <span>P. O. Box BE 277, Belvedere, Harare</span>
                        <span>Zimbabwe</span>
                    </div>

                    <div className='contact-us-item'>
                        <h1>Physical Address</h1>
                        <span>Harare Institute of Technology Campus</span>
                        <span>Ganges Road, Belvedere,</span>
                        <span>Harare</span>
                    </div>

                    <div className='contact-us-item'>
                        <h1>Telephone</h1>
                        <span>+263 242 741 422-36</span>
                    </div>

                    <div className='contact-us-item'>
                        <h1>Official Webiste</h1>
                        <span>
                            <a href='www.hit.ac.zw'>Harare Institute Of Technology</a>
                        </span>
                    </div>

                    <div className='contact-us-item  connect-with-us'>
                        <h1>Connect With Us</h1>
                        <div className='connect-icons'>
                            <span>
                                <FaFacebook
                                    color='white'
                                    size={clientWidth >= 768 && clientWidth <= 992 ? 30 : 20}
                                />
                            </span>
                            <span>
                                <FaYoutube
                                    color='red'
                                    size={clientWidth >= 768 && clientWidth <= 992 ? 30 : 20}
                                />
                            </span>
                            <span>
                                <FaTwitter
                                    color='white'
                                    size={clientWidth >= 768 && clientWidth <= 992 ? 30 : 20}
                                />
                            </span>
                            <span>
                                <FaLinkedin
                                    color='white'
                                    size={clientWidth >= 768 && clientWidth <= 992 ? 30 : 20}
                                />
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
